import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import type { ProgramacionAcademicaPage, StrapiBaseRequest } from '@/interfaces/strapi';
import { getProgramacionAcademica } from '@/services/strapi';
import { ROUTES } from '@/constants';
import { sidebarItems } from './sidebar';
import { queryParams } from './queryParams';

export const ProgramacionAcademica = (): ReactElement => {
	const {
		loading: loadingPage,
		data: page,
		error: errorPage,
	} = useStrapiApi<ProgramacionAcademicaPage, StrapiBaseRequest>(getProgramacionAcademica, {
		autoFetch: true,
		params: queryParams,
	});

	usePageBreadcrumb([
		{ label: 'Academia Matritense', to: ROUTES.ACADEMIA_MATRITENSE_HISTORIA },
		{ label: 'Programación Académica' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loadingPage) return <div className="u-mt-md">Cargando…</div>;
	if (errorPage) return <div className="u-mt-md">No se pudo cargar la página.</div>;
	if (!page) return <div className="u-mt-md">No se encontró la página.</div>;

	return (
		<div>
			<div className="o-strapi-page">
				<img src={page.image.url} alt={page.image.alt} />
			</div>
		</div>
	);
};
